import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const Home = () => {
    return (
        <div>
            <Helmet>
                <title>.rq Lab | Software Experiments and Practical Engineering</title>
                <meta
                    name="description"
                    content=".rq Lab shares practical software projects, performance engineering work, and applied tooling experiments."
                />
                <link rel="canonical" href="https://roamingquark.info/" />
            </Helmet>
            <h2>Welcome to .rq Lab</h2>
            <p>
                .rq Lab is a focused software studio working on performance-driven applications,
                browser tooling, and practical engineering experiments.
            </p>
            <p>
                Please <Link to="/contacts">reach out</Link> if you have a business inquiry.
            </p>
            <p>
                Visit <Link to="/information">Information</Link> and <Link to="/contacts">Contacts</Link>
                {' '}for project details and communication channels.
            </p>
        </div>
    )
}

export default Home;